import { ApiService } from '../../constants';
import { HttpService } from '../../utilities';

interface GetSearchConfig {
  search?: string;
  userin?: string;
  scheduleid?: string;
  page?: number;
  size?: number;
}

export const getSearchConfig = (search: string) => {
  return HttpService.get(
    `${ApiService.icdc.module.search.getConfig}?search=${search}`
  );
};

export const postSearchConfig = (data) => {
  return HttpService.post(ApiService.icdc.module.search.getConfig, data);
};

export const postSearchUmumConfig = (data) => {
  return HttpService.post(ApiService.icdc.module.search.searchUmum, data);
};
